import React, { Component } from 'react';
import axios from 'axios';
import moment from 'moment';
import config from '../../config';
import './index.css';

export let ButtonKind = {
    START_WORK: {
        rawValue: 'startWork',
        title: '勤務<br>開始',
        className: 'sm-start-work-button',
    },
    END_WORK: {
        rawValue: 'endWork',
        title: '勤務<br>終了',
        className: 'sm-end-work-button',
    },
    START_BREAK: {
        rawValue: 'startBreak',
        title: '休憩<br>入り',
        className: 'sm-start-break-button',
    },
    END_BREAK: {
        rawValue: 'endBreak',
        title: '休憩<br>戻り',
        className: 'sm-end-break-button',
    },
    FORGET_PRESS: {
        rawValue: 'forgetPress',
        title: '押し忘れ',
        className: 'sm-forget-press-button',
    },
};

export default class Button extends Component {
    constructor(props) {
        super(props)

        this.state = {
            disabled: props.disabled,
        };
    }

    componentWillReceiveProps(nextProp) {
        this.setState({
            disabled: nextProp.disabled,
        });
    }

    render() {
        let kind = this.props.kind;
        let className = `sm-button ${kind.className} m-3`;

        // title文字列に<br>が含まれる場合にDOMにちゃんと反映させる
        const title = kind.title.split('<br>').reduce((prev, current) => <span>{prev}<br/>{current}</span>);

        return (
            <button
                disabled={this.state.disabled}
                className={className}
                onClick={this.props.onClick}>
                {title}
            </button>
        );
    }

    handleClickButton = async (event) => {
        event.preventDefault();

        let date = moment().format('YYYY/MM/DD');
        let url = `${config.endpoint}/time/${date}`;
        let params = {
            kind: this.props.kind.rawValue,
            _: Date.now(),
        };
        let options = {
            headers: { 'x-api-key': config.apikey }
        };

        console.log('url', url);
        console.log('params', params);
        console.log('options', options);

        return await axios.post(url, params, options)
            .then(response => {
                // Add your code here
                console.log('response', response);
            }).catch(error => {
                console.error('error', error);
            });
    }
};



// WEBPACK FOOTER //
// ./src/components/record/Button.js